import { Injectable, InjectionToken, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { WINDOW } from './window.token';

/**
 * @stable
 */
export interface WindowOffsetProvider {
    getOffset(offset: number): Observable<number>;
}

/**
 * @stable
 */
export const WINDOW_OFFSET_PROVIDER = new InjectionToken<WindowOffsetProvider[]>('vn-window-offset-provider');

/**
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class WindowOffsetModifierService {
    private readonly windowOffsetProviders = inject(WINDOW_OFFSET_PROVIDER);

    readonly #window = inject(WINDOW);

    scrollBy(offset: number) {
        this.windowOffsetProviders.forEach((p) => {
            p.getOffset(offset).subscribe((scrollDiff) => {
                if (scrollDiff < 0) {
                    this.#window.scrollBy(0, scrollDiff);
                }
            });
        });
    }
}
